import { Platform } from 'react-native';

export const clientId = Platform.select({
  ios: 'NA',
  android: 'NA',
  web: 'bonanzasocial-web',
});
